import React, { createContext, useContext, useState } from 'react';

const CurrentStudentContext = createContext({
  currentStudent: null,
  setCurrentStudent: () => { },
});

export const CurrentStudentProvider = ({ children }) => {
  const [currentStudent, setCurrentStudent] = useState(null);

  return (
    <CurrentStudentContext.Provider value={{ currentStudent, setCurrentStudent }}>
      {children}
    </CurrentStudentContext.Provider>
  );
};

export const useCurrentStudent = () => {
  const context = useContext(CurrentStudentContext);
  if (!context) {
    throw new Error('useCurrentStudent must be used within CurrentStudentProvider');
  }
  return context;
};
